module.exports = __webpack_public_path__ + "img/reviews.698b1dd8.jpg";